export default {
	data: function() {
		return {
			current_step: 0
		}
	},
	props: ['provider_data'],
	methods: {
		setCurrentStep: function(step) {
			this.current_step = step;
		}
	}
}


// WEBPACK FOOTER //
// ./src/common/Reviews/Step3/step3.js